module.exports = __webpack_public_path__ + "media/images/logos/logo-lapis-black-eaafa0f6397db9e2f6d12fadecae3484.png";